import { action, observable } from 'mobx';
import { api } from '../config';
import { getCookie } from '../helpers/helpers';

// Dependencies
import moment from 'moment';

// Components
import SessionStore from './SessionStore';

var obx = observable({
  getCourseSid: action(function(courseSid) {
    if(courseSid) {
      let userData = {};

      if(SessionStore.hasSessionStorage) {
        userData = JSON.parse(sessionStorage.getItem('userData'));
      } else {
        userData = JSON.parse(getCookie('userData'));
      }

      userData.courseSid = courseSid;

      if(SessionStore.hasSessionStorage) {
        sessionStorage.setItem('userData', JSON.stringify(userData))
      } else {
        document.cookie = `userData=${JSON.stringify(userData)}`;
      }

      SessionStore.setUserData(userData)
    }
  }),
  exams: {},

  /**
   * Get all exams for a course
   * 
   * @function getExams
   * @param {string} courseSid
   * @param {boolean} hideSummary
   */
  getExams: action(function(courseSid, hideSummary) {
    SessionStore.startLoading('Loading…', 'CourseExams');

    obx.getCourseSid();

    let includeSummary = true;

    if(hideSummary) {
      includeSummary = false;
    }

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${courseSid || SessionStore.userData.courseSid}/exams?includeStatusSummary=${includeSummary}&sortKeys=examOpenDate`)
      .then(response => {
        obx.exams = response.data.results;
        SessionStore.finishLoading('CourseExams');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),

  /**
   * Get all exams for a course, sorted and grouped by status
   * 
   * @function getOrderedExams
   * @param {string} courseSid
   * @param {boolean} hideSummary
   */
  orderedExams: [],
  
  getOrderedExams: action((courseSid, hideSummary) => {
    SessionStore.startLoading('Loading…', 'CourseExams');

    obx.getCourseSid();

    let includeSummary = true;

    if(hideSummary) {
      includeSummary = false;
    }

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${courseSid || SessionStore.userData.courseSid}/exams/ordered?includeStatusSummary=${includeSummary}&sortKeys=examOpenDate`)
      .then(response => {
        obx.orderedExams = response.data.exams;
        SessionStore.finishLoading('CourseExams');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  instructorAppointments: [],
  getInstructorAppointments: action(function(courseSid) {
    SessionStore.startLoading('Loading…', 'GetInstructorAppointments');

    obx.instructorAppointments = [];

    obx.getCourseSid();

    api.get(`/installs/${SessionStore.userData.installSid}/reports/appointments?courseSid=${courseSid || SessionStore.userData.courseSid}&type=instructor-as-proctor&appointmentAfter=${moment().toISOString()}`)
      .then(response => {
        obx.instructorAppointments = response.data.results;

        SessionStore.finishLoading('GetInstructorAppointments')
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get exams as admin
  getExamsAsAdmin: action(function(courseSid) {
    SessionStore.startLoading('Loading…', 'CourseExamsAdmin');

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${courseSid}/exams?includeStatusSummary=true&sortKeys=title&sortKeys=examOpenDate`)
      .then(response => {
        obx.exams = response.data.results;
        SessionStore.finishLoading('CourseExamsAdmin');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get course offerings
  courseOfferings: [],
  getCourseOfferings: action(function() {
    SessionStore.startLoading('Loading…', 'GetCourseOfferings');

    api.get(`/installs/${SessionStore.userData.installSid}/courseOfferings`)
      .then(response => {
        obx.courseOfferings = response.data.results;
        SessionStore.finishLoading('GetCourseOfferings');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get a single course offering
  offering: {},
  getCourseOffering: action(function(sid, component) {
    SessionStore.startLoading('Loading…', 'GetCourseOffering');

    api.get(`/installs/${SessionStore.userData.installSid}/courseOfferings/${sid}`)
      .then(response => {
        obx.offering = response.data;
        SessionStore.finishLoading('GetCourseOffering');

        if(component) {
          component.setState({
            startDate: response.data.startDate,
            endDate: response.data.endDate
          })
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Create course offering
  createCourseOffering: action(function(callback) {
    SessionStore.startLoading('Loading…', 'CreateCourseOffering');

    let data = obx.offering;

    api.post(`/installs/${SessionStore.userData.installSid}/courseOfferings`, data)
      .then(response => {
        obx.offering = response.data;

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('CreateCourseOffering');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update course offering data
  updateOfferingData: action(function(data) {
    let newData = null;

    for(let key in data) {
      if(key) {
        newData = data[key];
        obx.offering[key] = newData;
      }
    }
  }),
  // Update course offering
  updateCourseOffering: action(function(sid, callback) {
    SessionStore.startLoading('Loading…', 'UpdateCourseOffering');

    let data = obx.offering;

    for(let prop in data) {
      if(
        prop !== 'title' &&
        prop !== 'matchStrings' &&
        prop !== 'startDate' &&
        prop !== 'endDate'
      ) {
        delete data[prop];
      }
    }

    api.put(`/installs/${SessionStore.userData.installSid}/courseOfferings/${sid}`, data)
      .then(response => {
        obx.offering = response.data;

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('UpdateCourseOffering');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete course offering
  deleteCourseOffering: action(function(sid, callback) {
    SessionStore.startLoading('Loading…', 'DeleteCourseOffering');

    api.delete(`/installs/${SessionStore.userData.installSid}/courseOfferings/${sid}`)
      .then(response => {
        SessionStore.finishLoading('DeleteCourseOffering');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  checkLastCourseSync: action(async function(syncInitTime, attempt = 0, callback) {
    if (SessionStore.loadingCalls.indexOf('scheduleSyncCheck') === -1) {
      SessionStore.startLoading('Loading...', 'scheduleSyncCheck');
    }

    if (attempt >= 24) {
      SessionStore.finishLoading('scheduleSyncCheck', true);
      if (callback) {
        callback();
      }
      return;
    }

    try {
      const response = await api.get(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}`);

      if (response.data.synchronization.enrollment &&
        syncInitTime
      ) {
        const courseSynced = moment(response.data.synchronization.enrollment.lastRun).isSameOrAfter(moment(syncInitTime));

        if (!courseSynced) {
          setTimeout(async () => await obx.checkLastCourseSync(syncInitTime, ++attempt, callback), 5000);
          return;
        } else {
          SessionStore.finishLoading('scheduleSyncCheck');
          if (callback) {
            callback();
          }
        }
      }
    } catch(error) {
      SessionStore.throwError(error);
    }
  })
});

export default obx;


// WEBPACK FOOTER //
// ./src/app/stores/CourseStore.js